import script from "./EmployeeBlock.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeBlock.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeBlock.vue?vue&type=style&index=0&id=64932ea8&lang=scss"

const __exports__ = script;

export default __exports__